"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toEthereumAddressOrENSName = void 0;
const EthereumAddress_1 = require("./EthereumAddress");
const ENSName_1 = require("./ENSName");
function toEthereumAddressOrENSName(str) {
    return (0, ENSName_1.isENSNameFormatIgnoreCase)(str) ? (0, ENSName_1.toENSName)(str) : (0, EthereumAddress_1.toEthereumAddress)(str);
}
exports.toEthereumAddressOrENSName = toEthereumAddressOrENSName;
//# sourceMappingURL=toEthereumAddressOrENSName.js.map